import React from "react";
import { List, Hidden, Button } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import { Close } from "@material-ui/icons";
import useWindowResizeListener from "hooks/useWindowResizeListener";
import style from "style";
import Item from "./Item";
import menus from "./menus";

const SideBar = ({ classes, onItemClick }) => {
  const { isMobile } = useWindowResizeListener();
  return (
    <div className={classes.list} style={{ zIndex: 99999 }}>
      <Hidden mdUp>
        <div style={{ paddingTop: "0.5rem", paddingBottom: "0.5rem" }}>
          <Button
            style={{ position: "absolute", right: "0" }}
            color="primary"
            onClick={onItemClick}
            onKeyDown={onItemClick}
          >
            {" "}
            <Close />
          </Button>
        </div>
      </Hidden>
      <List>
        {menus.map((item, idx) => {
          if (item.onlyShownOnMobile) {
            if (isMobile) {
              return (
                <Item
                  key={`${item.title}-${idx}`}
                  {...item}
                  onClick={onItemClick}
                />
              );
            }
            return;
          }
          return (
            <Item
              key={`${item.title}-${idx}`}
              {...item}
              onClick={onItemClick}
            />
          );
        })}
      </List>
    </div>
  );
};

export default withStyles(style)(SideBar);
